import Container from '@hellodarwin/core/lib/components/common/container';
import useMediaQuery from '@hellodarwin/core/lib/features/helpers/use-media-query';
import { useTheme } from 'styled-components';
import useOnboardingFlow from '../../../../hooks/useOnboardingFlow';
import OnboardingStepFooter from '../step-footer';
import OnboardingLayoutSectionHeader from '../step-header';
import { Wrapper } from './styles';
import { WrapperContainer } from './styles';

interface OnboardingLayoutFormContainerWrapperProps {
  children: React.ReactNode;
}
const OnboardingLayoutFormContainerWrapper: React.FC<
  OnboardingLayoutFormContainerWrapperProps
> = ({ children }) => {
  const { currentStepContent } = useOnboardingFlow();
  const {
    showHeader,
    title,
    description,
    hideStepper,
    hideBack,
    hideNext,
    showFooter,
    removeContainer,
    template,
  } = currentStepContent ?? {};

  const theme = useTheme();
  const isTablet = useMediaQuery({ maxWidth: theme.breakpoints.tablet });

  if (removeContainer) {
    return (
      <Wrapper
        style={{
          alignItems: template !== 'Welcome' ? 'center' : 'flex-start',
          width: template === 'Welcome' ? 'fit-content' : '100%',
        }}
      >
        <WrapperContainer>
          {showHeader && (
            <OnboardingLayoutSectionHeader
              title={title}
              description={description}
              showStepper={!hideStepper}
            />
          )}
          {children}
          {showFooter && (
            <OnboardingStepFooter hideBack={hideBack} hideNext={hideNext} />
          )}
        </WrapperContainer>
      </Wrapper>
    );
  }
  return (
    <Container
      styles={{
        container: {
          position: 'relative',
          zIndex: 1,
          maxWidth: '800px',
          justifyContent: 'center',
          backgroundColor: theme.colors.white_2,
        },
        content: {
          flex: 1,
          padding: isTablet ? theme.spacing.md : theme.spacing.lg,
          overflow: 'auto',
        },
      }}
      header={
        showHeader
          ? {
              label: (
                <OnboardingLayoutSectionHeader
                  title={title}
                  description={description}
                  showStepper={!hideStepper}
                />
              ),
            }
          : undefined
      }
      footer={
        showFooter
          ? {
              action: (
                <OnboardingStepFooter hideBack={hideBack} hideNext={hideNext} />
              ),
            }
          : undefined
      }
    >
      {children}
    </Container>
  );
};
export default OnboardingLayoutFormContainerWrapper;
